import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartLinesRemove = (
	`mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
		cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartLinesRemove;
